package com.karawek.core.ui.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Icon
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.karawek.core.ui.theme.CoreAlphas
import com.karawek.core.ui.theme.CoreShapes
import com.karawek.core.ui.theme.CoreSpacing
import com.karawek.core.ui.theme.CoreTheme
import com.karawek.core.ui.theme.CoreTypography

@Composable
fun CoreChip(
    selected: Boolean,
    label: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    leadingIcon: ImageVector? = null,
    iconSpacing: Dp = CoreSpacing.sm,
    shape: Shape = CoreShapes.lg,
) {
    val colors = CoreTheme.colors

    val background = when {
        !enabled -> colors.surfaceVariant.copy(alpha = CoreAlphas.DisabledSurface)
        selected -> colors.infoSurface
        else -> colors.surface
    }

    val borderColor = when {
        !enabled -> colors.divider.copy(alpha = CoreAlphas.Disabled)
        selected -> colors.infoAccent
        else -> colors.divider
    }

    val textColor = when {
        !enabled -> colors.textPrimary.copy(alpha = CoreAlphas.Disabled)
        selected -> colors.infoAccent
        else -> colors.textSecondary
    }

    Surface(
        onClick = onClick,
        enabled = enabled,
        shape = shape,
        color = background,
        border = BorderStroke(1.dp, borderColor),
        tonalElevation = 0.dp,
        shadowElevation = 0.dp,
        modifier = modifier.heightIn(min = 40.dp),
    ) {
        Row(
            modifier = Modifier
                .padding(horizontal = CoreSpacing.md, vertical = CoreSpacing.xs),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center,
        ) {
            leadingIcon?.let { icon ->
                Icon(
                    imageVector = icon,
                    contentDescription = null,
                    modifier = Modifier.size(16.dp),
                    tint = textColor,
                )
                Spacer(modifier = Modifier.width(iconSpacing))
            }
            Text(
                text = label,
                color = textColor,
                style = CoreTypography.bodySecondary,
            )
        }
    }
}
